import { ITagSearchItem } from './../../../../../common/types/hashtags.types';
import { useHashtagsApi } from './../../../../../hooks/use-mentions-api/use-hashtags-api/useHashtagsApi'
import { useMentionsApi } from 'hooks/use-mentions-api/useMentionsApi'
import { useAuth } from 'pages/auth/hooks/useAuth'
import { useState } from 'react'
import { IMentionable, IMentioned } from './../../../../../common/types/mentions.types'

export const useMentions = (isAdmin?: boolean) => {
  const { backendUser } = useAuth()
  const { fetchSearchMentionablesResult, fetchSearchResultsForChannelAdminByNameQuery } = useMentionsApi()
  const { fetchTagSearchResult } = useHashtagsApi()
  const [page, setPage] = useState(1)
  const [totalSuggestions, setTotalSuggestions] = useState(0)
  const [searchText, setSearchText] = useState('')
  const [users, setUsers] = useState<IMentionable[]>([])
  const [tagResults, setTagResults] = useState([])
  const [tags, setTags] = useState<Map<string, ITagSearchItem>>(new Map())
  const [mentions, setMentions] = useState<Map<string, IMentioned>>(new Map())

  const getResults = async (searchQuery?: string, shouldAppendChildren = true, getMentions = true, channelId?: string) => {
    if (backendUser?.id) {
      const currentPage = shouldAppendChildren ? page : 1
      let response
      const query = searchQuery ?? searchText

      setSearchText(query)

      if (!isAdmin) {
        if (getMentions) {
          response = await fetchSearchMentionablesResult(currentPage, 5, query, backendUser?.id)
        } else {
          response = await fetchTagSearchResult(currentPage, 5, query)
        }
      } else {
        response = await fetchSearchResultsForChannelAdminByNameQuery(currentPage, 5, query, backendUser?.id, channelId)
      }

      if (response) {

        const data = response.data
        setTotalSuggestions(parseInt(response.totalCount))

        if (shouldAppendChildren) {
          if (getMentions) {
            setUsers(prev => {
              return [...prev, ...(data as IMentionable[])]
            })
          } else {
            setTagResults(prev => {
              return [...prev, ...(data as ITagSearchItem[])]
            })
          }
          setPage(parseInt(response.page) + 1)
          return [...users, ...data]
        } else {
          if (getMentions) {
            setUsers(data as IMentionable[])
          } else {
            setTagResults(data as ITagSearchItem[])
          }
          setPage(parseInt(response.page) + 1)
          return data
        }
      }
    }
  }

  return {
    fetchSearchMentionablesResult,
    users,
    setPage,
    getResults,
    setUsers,
    setMentions,
    mentions,
    totalSuggestions,
    tagResults,
    setTagResults,
    tags,
    setTags,
    searchText,
  }
}
